import { ofType } from 'redux-observable';
import { of, Observable } from 'rxjs';
import {
  catchError,
  delay,
  ignoreElements,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';
import * as Sentry from '@sentry/react';

import { State } from '../root';
import { EpicDependencies } from '../epic-middleware';
import * as urls from '../urls';
import * as actions from './actions';
import * as types from './types';

export const startPasswordTokenValidation$ = (
  actions$: Observable<types.ValidatePasswordToken>,
  state$: Observable<State>,
  { http }: EpicDependencies,
) =>
  actions$.pipe(
    ofType(types.VALIDATE_PASSWORD_TOKEN),
    delay(1000),
    switchMap(({ token }) => {
      Sentry.logger.info('Validate Password Token', {
        token,
      });
      if (!token) {
        window.location.replace('/login');
        return [];
      }
      const url = `${urls.PASSWORD_RESET_URL}/${token}`;
      return http.get<boolean>({ url }).asObservable();
    }),
    tap((res) => {
      Sentry.logger.info('Validate Password Token Response', {
        response: res,
      });
    }),
    map((res) =>
      res
        ? actions.validatePasswordTokenSuccess()
        : actions.validatePasswordTokenFailure(),
    ),
    catchError((error) => {
      Sentry.logger.error('Validate Password Token Error', {
        error: error.message,
      });
      return [actions.validatePasswordTokenFailure()];
    }),
  );

export const setPassword$ = (
  actions$: Observable<types.SetPassword>,
  state$: Observable<State>,
  { http }: EpicDependencies,
) =>
  actions$.pipe(
    ofType(types.SET_PASSWORD),
    delay(1000),
    switchMap(({ password, token }) =>
      http
        .post<undefined>({
          url: urls.PASSWORD_URL,
          data: {
            password,
            passwordToken: token,
          },
        })
        .asObservable(),
    ),
    map(() => actions.setPasswordSuccess()),
    catchError(() => of(actions.setPasswordFailure())),
  );

export const setPasswordSuccessRedirect$ = (
  actions$: Observable<types.SetPasswordSuccess>,
  state$: Observable<State>,
) =>
  actions$.pipe(
    ofType(types.SET_PASSWORD_SUCCESS),
    delay(10000),
    tap(() => window.location.replace('/login')),
    ignoreElements(),
  );

export const passwordEpics = [
  startPasswordTokenValidation$,
  setPassword$,
  setPasswordSuccessRedirect$,
];
